import { getPresignedUrl } from "shared/api";
import { presignedUrlValidityHours } from "shared/constants";

const MAX_FILE_NAME_LENGTH = 1_024;

const charset =
  "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

const generateRandomString = (length: number): string =>
  Array.from({ length }, () =>
    charset.charAt(Math.floor(Math.random() * charset.length)),
  ).join("");

const sanitizeFileName = (fileName: string): string =>
  // eslint-disable-next-line no-control-regex
  fileName.replaceAll(/[^\u0000-\u007F]/g, "").slice(0, MAX_FILE_NAME_LENGTH) ||
  generateRandomString(8);

export const handleFilesUpload = async (files: File[], botId: string) => {
  const uploadResults = await Promise.all(
    files.map(async file => {
      const [fileName, extension] = file.name.split(/(?=\.[^.]+$)/);
      const tempFile = `${sanitizeFileName(fileName)}${extension}`;
      const fileKey = `${generateRandomString(16)}.${tempFile}`;

      // Get presigned URL
      const response = await getPresignedUrl({
        fileKey,
        mimetype: file.type,
        botId,
        validityHours: presignedUrlValidityHours,
      });
      const presignedUrl = response.presigned_url;

      // Upload file
      await fetch(presignedUrl, {
        method: "PUT",
        body: file,
        headers: {
          "content-type": file.type,
          "x-ms-blob-type": "BlockBlob",
        },
      });

      return {
        presignedUrl,
        fileKey,
      };
    }),
  );

  return uploadResults;
};
